import { EXTERNAL_RULE_TYPE } from '../../utils/constants';

export const USERS_URL = '/ECM/api/v5/user';
export const USERS_URL_GET = '/ECMv6/api/ext/users/search';
export const REQUESTABLE_USERS_URL_GET =
  '/ECM/api/v5/getrequestableusers?tileType=UpdateUserRequest&responsefields=username,firstname,lastname,middlename,displayname,statuskey,startdate,enddate,manager,customer,employeeType,departmentname,employeeid,email,userSource,identityType,title,city,secondaryManager,location&id=UPDATE';
export const USERS_URL_POST = '/ECMv6/post/users';
export const DASHBOARD_URL = '/ECMv6/api/ext/rules/dashboard';
export const RULES_URL_GET = '/ECMv6/api/ext/rules/search';
export const RULE_URL_POST = '/ECMv6/api/ext/rules'; // create a rule
export const RULE_UPDATE = '/ECMv6/api/ext/rules'; // put call to update rule
export const RULE_DELETE = '/ECMv6/api/ext/rules'; // delete call to delete a rule
export const RULE_GET = '/ECMv6/api/ext/rules'; // get rule details with path variable as rulekey /ECMv6/api/ext/rules/ruleKey
export const RULES_METADATA_GET = `/ECMv6/api/ext/rules/metadata?ruletype=${EXTERNAL_RULE_TYPE}`; // get rules metadata which contains attributes and operatirs details
export const IDP_VERIFICATION_POST = '/ECMv6/api/ext/idproofing/verification';
export const IDP_GENERATE_LINK_POST = '/ECMv6/api/ext/idproofing/generate-link';
export const FIVE_MINUTES_IN_MS = 5 * 60 * 1000;
export const IDP_CONFIG_POST = '/ECMv6/api/ext/idproofing/config'; // start id proofing with config post
export const IDP_PROVIDERS_URL_GET = '/ECMv6/api/ext/idproofing/search';
export const APPLY_RULES_POST = '/ECMv6/api/ext/rules/classification/start';
export const ECM_CONFIG_URL_POST = '/ECMv6/api/ext/ecmconfig/search'; // get ecm config
export const ECM_CONFIG_URL_PUT = '/ECMv6/api/ext/ecmconfig/update'; // update ecm config
